import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { fetchAuthSession } from 'aws-amplify/auth';

const BillingRedirect = () => {
  const navigate = useNavigate();
  const [error, setError] = useState(null);

  useEffect(() => {
    redirectToBilling();
  }, []);

  const redirectToBilling = async () => {
    try {
      const session = await fetchAuthSession();
      const token = session.tokens?.idToken?.toString();
      
      if (!token) {
        navigate('/');
        return;
      }

      // Call backend to create Stripe Connect Account Link
      const response = await fetch(`${process.env.REACT_APP_API_URL}/billing-portal`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error('Failed to create billing portal session');
      }

      const data = await response.json();
      window.open(data.url, '_blank'); // Open in new tab
      navigate('/dashboard'); // Return to dashboard
    } catch (error) {
      console.error('Billing portal error:', error);
      setError('Unable to access billing portal. Please try again.');
      setTimeout(() => navigate('/dashboard'), 3000);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        {error ? (
          <>
            <p className="text-red-600 mb-4">{error}</p>
            <p className="text-gray-600">Redirecting to dashboard...</p>
          </>
        ) : (
          <>
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
            <p className="mt-4 text-gray-600">Opening banking portal in new tab...</p>
          </>
        )}
      </div>
    </div>
  );
};

export default BillingRedirect;
